import { MappableModel } from './mappable-model'
import { Mapper } from '../services/mapper.service'
import { MembershipDefinition } from './membership-definition'
import { Persona } from './persona'
import { MembershipNumber } from './membership-number'
import { ElectronicDocumentAcceptance } from './electronic-document-acceptance'

export class Membership extends MappableModel {
  public affiliation_organization_id: number
  public cancel_date: Date | null
  public expires_at: Date | null
  public effective_at: string
  public id: string
  public label: string
  public membership_definition_id: string
  public membership_status: string
  public number: MembershipNumber
  public persona_id: number
  public purchase_date: Date | null
  public card_id: string

  private _persona: Persona
  private _membership_definition: MembershipDefinition
  private _electronicDocumentAcceptances: ElectronicDocumentAcceptance[]

  public set membership_definition(memdef: MembershipDefinition) {
    this._membership_definition = memdef
    this.membership_definition_id = memdef.id
  }

  public get membership_definition(): MembershipDefinition {
    return this._membership_definition
  }

  public set electronicDocumentAcceptances(acceptances: ElectronicDocumentAcceptance[]) {
    this._electronicDocumentAcceptances = acceptances
  }

  public get membershipStatus(): string {
    if (!this.membership_status) {
      return ''
    } else {
      return this.membership_status.toLowerCase()
    }
  }

  public get isValidOrUpcoming(): boolean {
    return this.membershipStatus === 'valid' || this.membershipStatus === 'pending'
  }

  public get isRequested(): boolean {
    return this.membershipStatus === 'requested'
  }

  public get isCanceled(): boolean {
    return this.membershipStatus === 'canceled'
  }

  public get isAssigned(): boolean {
    return !!this.affiliation_organization_id
  }

  public get isPublished(): boolean {
    return this.membership_definition.purchase_status !== 'unpublished'
  }

  public statusClass(): string {
    const status = this.membership_status.toLowerCase()
    if (status === 'valid') {
      return 'pl-tag--success'
    } else if (status === 'pending') {
      return 'pl-tag--highlight'
    } else {
      return 'pl-tag--caution'
    }
  }

  public get persona(): Persona {
    return this._persona
  }

  public set persona(persona: Persona) {
    this._persona = persona
    this.persona_id = persona.id
  }

  public deserialize(): void {
    this.membership_definition = Mapper.as<MembershipDefinition>(this.membership_definition, MembershipDefinition)
    this.number = Mapper.as<MembershipNumber>(this.number, MembershipNumber)
    this.cancel_date = this.cancel_date ? new Date(this.cancel_date) : null
    this.expires_at = this.expires_at ? new Date(this.expires_at) : null
    this.purchase_date = this.purchase_date ? new Date(this.purchase_date) : null
  }
}
